import { bchParam } from "../chain.js";
import { UnitEnum } from "../enum.js";
import { floor } from "./floor.js";
import { ExchangeRate } from "../rate/ExchangeRate.js";
import { sanitizeUnit } from "./sanitizeUnit.js";
import { Config } from "../config.js";
export async function balanceResponseFromSatoshi(value, priceCache = true) {
    const response = {};
    response.bch = value / bchParam.subUnits;
    response.sat = value;
    const currencyValue = (value / bchParam.subUnits) *
        (await ExchangeRate.get(Config.DefaultCurrency, priceCache));
    response[Config.DefaultCurrency] = floor(currencyValue, 2);
    return response;
}
export async function balanceFromSatoshi(value, rawUnit, priceCache = true) {
    const unit = sanitizeUnit(rawUnit);
    switch (unit) {
        case UnitEnum.BCH:
            return value / bchParam.subUnits;
        case UnitEnum.SAT:
            return value;
        case UnitEnum.SATS:
            return value;
        case UnitEnum.SATOSHI:
            return value;
        case UnitEnum.SATOSHIS:
            return value;
        default:
            const currencyValue = (value / bchParam.subUnits) *
                (await ExchangeRate.get(Config.DefaultCurrency, priceCache));
            return Number(currencyValue.toFixed(2));
    }
}
//# sourceMappingURL=balanceObjectFromSatoshi.js.map